import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {shortOid} from './short-oid'

export function MergedText({info}: {info: IssueEventInfo}) {
  const {commitOid} = info
  if (!commitOid) return <>merged</>
  return (
    <>
      merged commit <strong>{shortOid(commitOid)}</strong>
    </>
  )
}
